import { memo, useMemo } from "react";
import { APP_LANGUAGE } from "../constants/intl.ts";

type ForwardedDateTimeFormatOptions =
  | Pick<Intl.DateTimeFormatOptions, "dateStyle" | "timeStyle">
  | Pick<
      Intl.DateTimeFormatOptions,
      | "day"
      | "month"
      | "year"
      | "hour"
      | "minute"
      | "second"
      | "timeZone"
      | "timeZoneName"
      | "weekday"
      | "hour12"
    >;

export const FormattedDate = memo(
  ({
    className,
    value,
    ...options
  }: {
    value: string | Date;
    className?: string;
  } & ForwardedDateTimeFormatOptions) => {
    const i18n = useMemo(() => {
      return {
        locale: APP_LANGUAGE,
      };
    }, []);

    const date = new Date(value);
    const formattedDate = date.toLocaleString(i18n.locale, options);

    return (
      <time className={className} dateTime={date.toISOString()}>
        {formattedDate}
      </time>
    );
  },
);

FormattedDate.displayName = "FormattedDate";
